import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, ChipsTogglerButton, FlatTextInput, useDebounce } from '@common-fe/common-fe';

import { OptionalFieldsWrapper } from '@/modules/UseMyMoney/components';
import { useMyMoneyFormStore } from '@/modules/UseMyMoney/stores';

const BillDetails = () => {
  const { t } = useTranslation();
  const {
    values,
    isAccountNumberEnabled,
    isInvoiceNumberEnabled,
    handleSetState,
    handleSetFormValues,
  } = useMyMoneyFormStore();

  const [accountNumber, setAccountNumber] = useState(values?.accountNumber);
  const debouncedAccountNumber = useDebounce(accountNumber);

  const [invoiceNumber, setInvoiceNumber] = useState(values?.invoiceNumber);
  const debouncedInvoiceNumber = useDebounce(invoiceNumber);

  const handleSetIsAccountNumberEnabled = useCallback((value: boolean) => {
    handleSetState({ isAccountNumberEnabled: value });
  }, [handleSetState]);

  const handleSetIsInvoiceNumberEnabled = useCallback((value: boolean) => {
    handleSetState({ isInvoiceNumberEnabled: value });
  }, [handleSetState]);

  useEffect(() => {
    handleSetFormValues({ accountNumber: debouncedAccountNumber });
  }, [handleSetFormValues, debouncedAccountNumber]);

  useEffect(() => {
    handleSetFormValues({ invoiceNumber: debouncedInvoiceNumber });
  }, [handleSetFormValues, debouncedInvoiceNumber]);

  return (
    <Box>
      <Box direction="row" gap="spacing8">
        {isAccountNumberEnabled ? null : (
          <ChipsTogglerButton
            testId="add-account-number"
            onClick={() => handleSetIsAccountNumberEnabled(true)}
            title={t('Add Account #')}
            pad={{ horizontal: 'spacing12', vertical: '10px' }}
            value="add-account-number"
            width="50%"
          /> 
        )}

        {isInvoiceNumberEnabled ? null : (
          <ChipsTogglerButton
            testId="add-invoice-number"
            onClick={() => handleSetIsInvoiceNumberEnabled(true)}
            title={t('Add Invoice #')}
            pad={{ horizontal: 'spacing12', vertical: '10px' }}
            value="add-invoice-number"
            width="50%"
          />
        )}
      </Box>

      <Box margin={{ top: 'spacing8' }} gap="spacing24">
        {isAccountNumberEnabled ? (
          <OptionalFieldsWrapper
            testId="account-number"
            title={t('Account #')}
            onClose={() => handleSetIsAccountNumberEnabled(false)}
            width="calc(50% - 4px)"
          >
            <FlatTextInput
              testId="account-number"
              value={accountNumber as string}
              onChange={setAccountNumber}
              placeholder={t('Enter account #')}
              name="account-number"
              hideTip
            />
          </OptionalFieldsWrapper>
        ) : null}

        {isInvoiceNumberEnabled ? (
          <OptionalFieldsWrapper
            testId="invoice-number"
            title={t('Invoice #')}
            onClose={() => handleSetIsInvoiceNumberEnabled(false)}
            width="calc(50% - 4px)"
          >
            <FlatTextInput
              testId="invoice-number"
              value={invoiceNumber as string}
              onChange={setInvoiceNumber}
              placeholder={t('Enter invoice #')}
              name="invoice-number"
              hideTip
            />
          </OptionalFieldsWrapper>
        ) : null}
      </Box>
    </Box>
  );
};

export default BillDetails;
